import { formatTaiwanDateTimeAMPM } from "../../utils";

const TruckLoanApplicationCheckModal = ({ getStatusBadge, selectedApp, modalType, setShowModal, rejectReason, setRejectReason, handleApprove, handleReject, handleCancel, handleApproveCancelRequest, handleRejectCancelRequest }) => {
    // 格式化日期
    const formatDate = (dateStr) => {
        if (!dateStr) return '-';
        return new Date(dateStr).toLocaleString('zh-TW', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit'
        });
    };
    return (
        <>
            <div className="modal-overlay" onClick={() => setShowModal(false)}>
                <div className="modal-content" onClick={e => e.stopPropagation()}>
                    <div className="modal-header">
                        <h5>
                            {modalType === 'approve' && '✅ 確認核准'}
                            {modalType === 'reject' && '❌ 駁回申請'}
                            {modalType === 'cancel' && '🚫 申請取消'}
                            {modalType === 'approveCancelRequest' && '✅ 核准取消申請'}
                            {modalType === 'rejectCancel' && '❌ 駁回取消申請'}
                            {modalType === 'view' && '📋 申請詳情'}
                        </h5>
                        <button className="btn-close" onClick={() => setShowModal(false)}></button>
                    </div>
                    <div className="modal-body">
                        <div className="application-detail">
                            <div className="detail-row">
                                <label>狀態：</label>
                                {getStatusBadge(selectedApp.status)}
                            </div>
                            <div className="detail-row">
                                <label>派車單ID：</label>
                                <span>{selectedApp.deliverOrderId}</span>
                            </div>
                            <div className="detail-row">
                                <label>申請人：</label>
                                <span>{selectedApp.applicantName} ({selectedApp.department})</span>
                            </div>
                            <div className="detail-row">
                                <label>車輛：</label>
                                <span>{selectedApp.vehicle?.plate || '-'} - {selectedApp.vehicle?.model || '-'}</span>
                            </div>
                            <div className="detail-row">
                                <label>行駛地點：</label>
                                <span>{selectedApp.destination}</span>
                            </div>
                            <div className="detail-row">
                                <label>用車時間：</label>
                                <span>{formatTaiwanDateTimeAMPM(selectedApp.startAt)} ~ {formatTaiwanDateTimeAMPM(selectedApp.endAt)}</span>
                            </div>
                            <div className="detail-row">
                                <label>申請用途</label>
                                <span>{selectedApp.purpose}</span>
                            </div>
                            <div className="detail-row">
                                <label>申請日期：</label>
                                <span>{selectedApp.applicantDate || '-'}</span>
                            </div>
                            <div className="detail-row">
                                <label>手機號碼：</label>
                                <span>{selectedApp.cellphone || '-'}</span>
                            </div>
                            <div className="detail-row">
                                <label>辦公室電話：</label>
                                <span>{selectedApp.phone || '-'}</span>
                            </div>
                            <div className="detail-row">
                                <label>單位主管：</label>
                                <span>{selectedApp.unitSupervisor || '-'}</span>
                            </div>


                            {selectedApp.managerId && (
                                <div className="detail-row">
                                    <label>核准主管：</label>
                                    <span>{selectedApp.manager.name || '-'}</span>
                                </div>
                            )}

                            <hr className="my-3" />
                            <h6 className="mb-3"><strong>車輛返還記錄</strong></h6>

                            <div className="detail-row">
                                <label>借出/歸還時間：</label>
                                <span>{formatDate(selectedApp.actualCheckoutAt)} ~ {formatDate(selectedApp.actualReturnAt)}</span>
                            </div>
                            <div className="detail-row">
                                <label>行前檢查情況：</label>
                                <span>{selectedApp.preCheckStatus || '-'}</span>
                            </div>
                            <div className="detail-row">
                                <label>行後檢查情況：</label>
                                <span>{selectedApp.postCheckStatus || '-'}</span>
                            </div>
                            <div className="detail-row">
                                <label>申請人：</label>
                                <span>{selectedApp.applicantName} ({selectedApp.department})</span>
                            </div>
                            <div className="detail-row">
                                <label>保管人員：</label>
                                <span>{selectedApp.custodian || '-'}</span>
                            </div>

                            {(selectedApp.reason && selectedApp.status === 'rejected') && (
                                <div className="detail-row">
                                    <label>駁回原因：</label>
                                    <span className="text-danger">{selectedApp.reason}</span>
                                </div>
                            )}

                            {(selectedApp.cancelReason && (selectedApp.status === 'cancelled' || selectedApp.isCancelRequest)) && (
                                <div className="detail-row">
                                    <label>取消原因：</label>
                                    <span className="text-secondary">{selectedApp.cancelReason}</span>
                                </div>
                            )}
                        </div>

                        {modalType === 'approve' && (
                            <div className="alert alert-success mt-3">
                                {(selectedApp.actualCheckoutAt && selectedApp.actualReturnAt && selectedApp.preCheckStatus && selectedApp.postCheckStatus) ? '還車核准'
                                    : selectedApp.status === 'repentant' ? '派車單修改重審'
                                        : '確定要核准此借車申請嗎？核准後申請人可以使用車輛。'}
                            </div>
                        )}

                        {modalType === 'reject' && (
                            <div className="mt-3">
                                <label className="form-label">駁回原因 <span className="text-danger">*</span></label>
                                <textarea
                                    className="form-control"
                                    rows="3"
                                    value={rejectReason}
                                    onChange={(e) => setRejectReason(e.target.value)}
                                    placeholder="請輸入駁回原因..."
                                />
                            </div>
                        )}

                        {modalType === 'cancel' && (
                            <div className="mt-3">
                                <label className="form-label">取消原因 <span className="text-danger">*</span></label>
                                <textarea
                                    className="form-control"
                                    rows="3"
                                    value={rejectReason}
                                    onChange={(e) => setRejectReason(e.target.value)}
                                    placeholder="請輸入取消原因..."
                                />
                            </div>
                        )}

                        {modalType === 'approveCancelRequest' && (
                            <div className="alert alert-info mt-3">
                                <p><strong>確認核准此取消申請嗎？</strong></p>
                                <p>取消原因：{selectedApp.cancelReason}</p>
                                <p>核准後，借車申請狀態將改為已取消。</p>
                            </div>
                        )}

                        {modalType === 'rejectCancel' && (
                            <div className="alert alert-warning mt-3">
                                <p><strong>確認駁回此取消申請嗎？</strong></p>
                                <p>駁回後，申請將恢復為已核准狀態。</p>
                            </div>
                        )}
                    </div>
                    <div className="modal-footer">
                        <button
                            className="btn btn-secondary"
                            onClick={() => setShowModal(false)}
                        >
                            {modalType === 'view' ? '關閉' : '取消'}
                        </button>
                        {modalType === 'approve' && (

                            <button
                                className="btn btn-success"
                                onClick={handleApprove}
                            >
                                {(selectedApp.actualCheckoutAt && selectedApp.actualReturnAt && selectedApp.preCheckStatus && selectedApp.postCheckStatus)
                                    ? '核准還車' : '確認核准'}
                            </button>
                        )}
                        {modalType === 'reject' && (
                            <button
                                className="btn btn-danger"
                                onClick={handleReject}
                            >
                                確認駁回
                            </button>
                        )}
                        {modalType === 'cancel' && (
                            <button
                                className="btn btn-warning"
                                onClick={handleCancel}
                            >
                                確認申請取消
                            </button>
                        )}
                        {modalType === 'approveCancelRequest' && (
                            <button
                                className="btn btn-success"
                                onClick={handleApproveCancelRequest}
                            >
                                確認核准取消
                            </button>
                        )}
                        {modalType === 'rejectCancel' && (
                            <button
                                className="btn btn-danger"
                                onClick={handleRejectCancelRequest}
                            >
                                確認駁回取消
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </>
    )
};

export { TruckLoanApplicationCheckModal };